/*
 * NFT Landing Page - Sailing Ships Collection
 * Copyright (C) 2025 jsaif
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 *
 * Original project: https://github.com/s-shemmee/NFT-Portfolio-Landing-Page
 * Original creator: s-shemmee
 */

import React, { useEffect } from "react";
import PropTypes from "prop-types";
import HomePage from "./HomePage";
import { initTransientScrollbar, destroyTransientScrollbar } from "./utils/scrollbarUtils";

// Error Boundary Component for better error handling
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("NFT Portfolio Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            background: "#000",
            color: "#DAA520",
            fontFamily: "Lora, serif",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <h1>🚀 Oops! Something went wrong</h1>
          <p>Our cosmic journey hit a small asteroid. Please refresh the page to continue exploring.</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: "linear-gradient(135deg, #DAA520, #FFD700)",
              border: "none",
              borderRadius: "8px",
              padding: "12px 24px",
              color: "#000",
              fontWeight: "bold",
              cursor: "pointer",
              marginTop: "20px",
            }}
          >
            Reload Journey
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

function App() {
  // Initialize transient scrollbar on component mount
  useEffect(() => {
    initTransientScrollbar();

    // Cleanup on unmount
    return () => {
      destroyTransientScrollbar();
    };
  }, []);
  return (
    <ErrorBoundary>
      <HomePage />
    </ErrorBoundary>
  );
}

export default App;
